/* Ripe & Ready — the header menu, and in-page navigation.

   The header links jump to a section on the same page. Left alone, the browser
   snaps the section to the very top edge, under the sticky header, which hides
   the heading the customer just clicked.

   This glides instead, and parks the section in the middle of the screen.

   The links are written as "/#how", not "#how", because Shopify menu settings
   store a path. So a plain a[href^="#"] test misses every one of them. The test
   below compares the whole URL: same host, same path, and a hash. That covers
   "/#how", "#how" and the full "https://shop/#how" alike, and still lets a link
   to another page navigate normally.

   Styles and markup: sections/rr-header.liquid, sections/rr-*.liquid anchors.
*/
(function () {
  "use strict";

  /* ---- the narrow-screen menu --------------------------------------------
     The four header links do not fit beside the wordmark and the Build your
     box button on a phone. Below 860px the stylesheet turns the same list into
     a panel that drops out of the bar; this opens and closes it.

     The button exists at every width, and the stylesheet hides it on desktop.
     So this code must never apply the hidden attribute on desktop, or the
     links would vanish with no way to get them back.
     ---------------------------------------------------------------------- */
  var NARROW = "(max-width: 860px)";

  function startMenu() {
    var btn = document.getElementById("rr-menu-btn");
    var menu = document.getElementById("rr-menu");
    if (!btn || !menu) {
      return;
    }

    function narrow() {
      return window.matchMedia(NARROW).matches;
    }

    function setOpen(open) {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        menu.removeAttribute("hidden");
      } else {
        menu.setAttribute("hidden", "");
      }
    }

    if (narrow()) {
      setOpen(false);
    }

    btn.addEventListener("click", function () {
      setOpen(btn.getAttribute("aria-expanded") !== "true");
    });

    /* Tapping a link closes the panel. The smooth-scroll handler below then
       takes the click as normal, so the panel is already out of the way when
       the page starts moving.

       The narrow() guard is not optional. On desktop the links live in the bar
       itself, and closing "the panel" there hides the whole navigation — which
       is exactly what happened: click a header link on desktop, and the links
       never came back. */
    menu.addEventListener("click", function (e) {
      if (!narrow()) {
        return;
      }
      if (e.target && typeof e.target.closest === "function" && e.target.closest("a")) {
        setOpen(false);
      }
    });

    document.addEventListener("click", function (e) {
      if (!narrow()) {
        return;
      }
      if (!e.target || typeof e.target.closest !== "function") {
        return;
      }
      if (e.target.closest("#rr-menu") || e.target.closest("#rr-menu-btn")) {
        return;
      }
      setOpen(false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && btn.getAttribute("aria-expanded") === "true") {
        setOpen(false);
        btn.focus();
      }
    });

    /* Crossing the breakpoint hands the links back to the bar. Without this, a
       menu left closed on a phone stays hidden when the screen gets wider. */
    var mq = window.matchMedia(NARROW);
    var onChange = function (m) {
      if (m.matches) {
        setOpen(false);
      } else {
        menu.removeAttribute("hidden");
      }
    };
    if (mq.addEventListener) {
      mq.addEventListener("change", onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startMenu);
  } else {
    startMenu();
  }

  /* ---- in-page anchors ---------------------------------------------------- */
  function sameDocumentHash(a) {
    var raw = a.getAttribute("href");
    if (!raw || raw.indexOf("#") === -1) {
      return "";
    }
    var url;
    try {
      url = new URL(a.href, window.location.href);
    } catch (err) {
      return "";
    }
    if (url.host !== window.location.host) {
      return "";
    }
    if (url.pathname !== window.location.pathname) {
      return "";
    }
    if (!url.hash || url.hash === "#") {
      return "";
    }
    return url.hash;
  }

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }
    var start = e.target;
    if (!start || typeof start.closest !== "function") {
      return;
    }
    var a = start.closest("a[href]");
    if (!a || a.target === "_blank") {
      return;
    }

    var hash = sameDocumentHash(a);
    if (!hash) {
      return;
    }

    var target;
    try {
      target = document.querySelector(hash);
    } catch (err) {
      return;
    }
    if (!target) {
      return;
    }

    e.preventDefault();

    /* Someone who has asked their computer for less motion gets the jump, not
       the glide. A long smooth scroll can make those people feel unwell. */
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });

    /* Keep the address bar honest without letting the browser jump as well. */
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, "", hash);
    }
  });
})();
